import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkParagraphSizes, UitkTypeOverflows } from "./types.js";
export function UitkParagraph({
  size = 2,
  overflow,
  children,
  className,
  style,
  ...attributes
}) {
  const baseClassName = "uitk-paragraph";
  const wrapperClassNames = classNames(baseClassName, size && UitkParagraphSizes.get(size), overflow && UitkTypeOverflows.get(overflow), className);
  return children ? /* @__PURE__ */ React.createElement("p", { className: wrapperClassNames, style, ...attributes }, children) : null;
}
;
UitkParagraph.displayName = "UitkParagraph";
